<!-- 金融服务-展示块 -->
<template>
<div class="info-block">
  <router-link :to="{path: '#'}" class="info-block-a">
    <div class="div-1">
      <div class="div-2" v-bind:style='{backgroundImage:info.imgUrl}'></div>
      <div class="div-1-1">{{info.name}}</div>
      <div class="div-1-2">{{info.desc.replace(/<[^>]*>/g,'').substring(0,80)}}</div>
      <div class="div-3">
        <a class="td-action-1">了解详情</a>
      </div>
    </div>
  </router-link>
</div>
</template>

<script>
export default {
  name: 'JrfwInfo1',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:150px;
  padding:0px 0px 0px 0px;
  margin:8px;
  background-color: #e6e6e6;
  border:1px solid #e6e6e6;
  background-size: 100px auto;
  background-repeat: no-repeat;
  background-position: 10px center;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px var(--color6);
}

.div-1{
  position:relative;
  height:100%;
  width:100%;
  padding:0px 150px 0px 0px;
  //background:#fff;

}

.div-1-1{
  position:relative;
  height:40px;
  font-size:14px;
  font-weight:600;
  text-align:left;
  line-height:40px;
  color:#000;
  padding:5px 5px 5px 120px;
}

.div-1-2{
  position:relative;
  height:60px;
  font-size:12px;
  text-align:left;
  line-height:20px;
  color:#515151;
  padding:5px 5px 5px 120px;
}


.div-2{
  position:relative;
  float:left;
  height:100%;
  width:100px;
  padding:0px 0px 0px 0px;
  //background:#fff;
  background-size: 80px auto;
  background-repeat: no-repeat;
  background-position: 10px center;

}


.div-3{
  position:absolute;
  top:0px;
  right:0px;
  width:100px;
  margin:15px 20px 15px 0px;
  padding-left:10px;
  //background:yellow;
}

.div-3 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-top:40px;
  border:1px solid var(--color7);
  color:#000;
  line-height:20px;
  text-align:center;
}

.td-action-1:hover{
  background: var(--color7);
  color:#fff;
}

.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/module/JrfwInfo1.vue